import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { store } from './store';
import './index.css';
import App from './App.tsx';
import { getEnv } from './utils/env';

const dsn = getEnv('VITE_SENTRY_DSN');

if (dsn) {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <Sentry.ErrorBoundary fallback={
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: 'var(--bg-primary, #0d0f12)',
          color: 'var(--text-primary, #ffffff)',
          fontFamily: 'Inter, system-ui, sans-serif',
          textAlign: 'center',
          padding: '20px'
        }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '10px', color: 'var(--accent-primary, #ff007f)' }}>Something went wrong</h1>
          <p style={{ color: 'var(--text-secondary, #a0aec0)', marginBottom: '20px' }}>Our team has been notified. Please try reloading the page.</p>
          <button 
            onClick={() => window.location.reload()} 
            style={{
              padding: '10px 20px',
              backgroundColor: 'var(--btn-primary, #ff007f)',
              color: '#ffffff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 600,
              transition: 'background-color 0.2s'
            }}
          >
            Reload Page
          </button>
        </div>
      }>
        <App />
      </Sentry.ErrorBoundary>
    </Provider>
  </StrictMode>,
);

